<template>
  <div class="article-search-container">
    <a-input-search
      placeholder="请输入姓名、医院、手机号..."
      style="width:250px"
      allow-clear
      @search="value => $emit('onSearch', value)"
    />
    <a-select
      style="width:150px"
      class="select-container"
      placeholder="请选择状态"
      @change="value => $emit('onChangeStatus', value)"
    >
      <a-select-option
        v-for="item in statusData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-select
      style="width:150px"
      class="select-container"
      placeholder="请选择激活状态"
      @change="value=>$emit('onChangeActiva',value)"
    >
      <a-select-option
        v-for="item in typeData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-select
      style="width:200px"
      class="select-container"
      placeholder="请选择职称"
      @change="value => $emit('onChangeRank', value)"
    >
      <a-select-option
        v-for="item in rankData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>

    <a-tree-select
      class="select-container"
      style="width:150px"
      :tree-data="sectionData"
      placeholder="请选择科室"
      @change="value => $emit('onChangeSection', value)"
    />
    <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      新增医生
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusData: [
        {id: 0, name: '全部'},
        {id: 1, name: '未验证'},
        {id: 2, name: '审核中'},
        {id: 3, name: '不通过'},
        {id: 4, name: '已通过'},
      ],
      typeData: [{id: -1, name: '所有'}, {id: 1, name: '已激活'}, {id: 0, name: '未激活'}],
      rankData: [{id: '0', name: '所有'}],
      sectionData: [{value: '0', key: 0, title: '所有'}],
    };
  },
  mounted(){
    // 获取科室
    this.getSectionData();
    // 获取职称数据
    this.getRankData();

  },
  methods: {
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        item.title=item.name;
        item.key=item.id;
        item.value=String(item.id);
        item.children=item.child_list;
        if (item.child_list && item.child_list.length > 0) {
          this.dealData(item.child_list);
        }
      });
      return data;
    },
    // 获取职称数据
    async getRankData() {
      let result = await this.$http.post('/system/getProfessionalList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.rankData =[...this.rankData, ...data];
      }
    },
    // 获取科室数据
    async getSectionData() {
      let result = await this.$http.post('/system/getDepartmentList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.sectionData = [...this.sectionData, ...this.dealData(JSON.parse(JSON.stringify(data)))];
      }
    },
  },
};
</script>
<style lang="scss">
.article-search-container {
  min-height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 20px;
    margin-right: 20px;
  }
  .select-container{
    margin:0 5px;
  }
}
</style>
